export interface TripProtectionBanner {
  icon: BannerImage;
  tripProtectionBannerLabel: string;
  tripProtectionBannerMessage1: string;
  tripProtectionBannerMessage2: string;
  tripProtectionTitle: string;
}

export interface BannerImage {
  iconPath: string;
  altLabel: string;
}
